import React from 'react'

const Skills = () => {
    return (
        <section id="services">
            <h2>Skills</h2>
            <div className="container skills__container">
                <article className="skills-item">
                    <h3>Django</h3>
                </article>
                <article className="skills-item">
                    <h3>MERN</h3>
                </article>
                <article className="skills-item">
                    <h3>ReactJS</h3>
                </article>
                <article className="skills-item">
                    <h3>NodeJS</h3>
                </article>
                <article className="skills-item">
                    <h3>ExpressJS</h3>
                </article>
                <article className="skills-item">
                    <h3>MongoDB</h3>
                </article>
                <article className="skills-item">
                    <h3>SQL</h3>
                </article>
                <article className="skills-item">
                    <h3>JavaScript</h3>
                </article>
                <article className="skills-item">
                    <h3>Postman</h3>
                </article>
                <article className="skills-item">
                    <h3>Python</h3>
                </article>
                <article className="skills-item">
                    <h3>C++</h3>
                </article>
                <article className="skills-item">
                    <h3>Flask</h3>
                </article>
                <article className="skills-item">
                    <h3>HTML</h3>
                </article>
                <article className="skills-item">
                    <h3>CSS</h3>
                </article>
                <article className="skills-item">
                    <h3>Linux</h3>
                </article>
                <article className="skills-item">
                    <h3>Git/Github</h3>
                </article>
            </div>
        </section>
    )
}

export default Skills
